<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" :hide-details="true" />
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center mb-4">
            <label class="label-input mb-0">Markqueue Items</label>
            <v-btn small text color="primary" @click="handleAddMarkqueueItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-row class="mb-4">
              <v-col cols="6">
                <ColorPicker
                  v-model="fields.backgroundMarkqueue"
                  name="backgroundMarkqueue"
                  label="Background Color"
                  default-color="#006196"
                />
              </v-col>
              <v-col cols="6">
                <ColorPicker
                  v-model="fields.textColorMarkqueue"
                  name="textColorMarkqueue"
                  label="Text Color"
                  default-color="#ffffff"
                />
              </v-col>
            </v-row>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields.markqueueItems" :key="`markqueue-${i}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>{{ item.text }}</span>
                    <v-btn icon @click.stop="handleRemoveMarkqueueItem(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <UploadImage
                    @callback="obj => handleUploadMarkqueueIcon(obj, i)"
                    :image="{ imageSrc: item.icon }"
                    :height="`100`"
                    :typeUpload="'image'"
                    @callbackDelete="handleRemoveMarkqueueIcon(i)"
                  />
                  <v-text-field
                    :value="item.text"
                    :hide-details="true"
                    class="mt-3"
                    @input="val => handleUpdateMarkqueueText(val, i)"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { updateHtmlFromData } from '../common/html/update.js';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import ColorPicker from './common/color-picker.vue';

export default {
  name: 'MarkqueueOrthopedicSectionEditor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: {
        title: 'Markqueue Orthopedic Section',
        enableAnchor: false,
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        backgroundMarkqueue: '#006196',
        textColorMarkqueue: '#ffffff',
        markqueueItems: [{ icon: '', text: '' }],
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        markqueueItems: Array.isArray(extract.markqueueItems) ? extract.markqueueItems : this.fields.markqueueItems,
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionMarkqueueOrthopedic(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadMarkqueueIcon(obj, index) {
      this.fields.markqueueItems[index].icon = obj.imageSrc;
    },
    handleRemoveMarkqueueIcon(index) {
      this.fields.markqueueItems[index].icon = '';
    },
    handleUpdateMarkqueueText(value, index) {
      this.fields.markqueueItems[index].text = value;
    },
    handleAddMarkqueueItem() {
      this.fields.markqueueItems.push({
        icon: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0aa2e4d4acd54fd1b4306.png?w=200',
        text: 'Free Shipping - Free Returns - Free Exchanges',
      });
    },
    handleRemoveMarkqueueItem(index) {
      if (this.fields.markqueueItems.length <= 1) return;
      this.fields.markqueueItems.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
